export default {
  contents: Array,
}
